module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/icon_lead_point_check-78181ea4ff4e13bb31845f2c0052d57e.svg";